import React, { useEffect } from 'react'
import { gsap } from 'gsap'

export default function Footer() {
  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(
        'footer .footer__inner',
        { opacity: 0, y: 30 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: 'footer',
            start: 'top 90%',
            once: true,
          },
        }
      )
    }, document.querySelector('footer') || undefined)

    return () => ctx.revert()
  }, [])

  return (
    <footer>
      <div className="footer__inner">
        <div className="footer__brand">
          <span className="footer__logo">Aure Studio</span>
          <p className="footer__tagline">The People Groomers · Kerala, India</p>
        </div>
        <div className="footer__links">
          <a href="#services">Services</a>
          <a href="#maison">Maison</a>
          <a href="#reservations">Book</a>
          <a href="https://wa.me/919746465574" target="_blank" rel="noopener noreferrer">WhatsApp</a>
        </div>
        <p className="footer__copy">
          © {new Date().getFullYear()} Aure Studio. All rights reserved.
        </p>
      </div>
    </footer>
  )
}